<template>
  <div class="editBread">
    <a-breadcrumb>
      <a-breadcrumb-item @click="jumpPage">公共功能配置</a-breadcrumb-item>
      <a-breadcrumb-item>Footer政策条款</a-breadcrumb-item>
    </a-breadcrumb>
  </div>
</template>
<script>
import { inject, toRefs } from 'vue'
export default {
  setup() {
    return {
      ...toRefs(inject('initState'))
    }
  }
}
</script>
<style lang="scss" scoped>
.editBread {
  background: #ffffff;
  margin: 15px;
  padding: 15px 20px;
}
</style>
